<ngx-spinner
	bdColor="rgba(75, 55, 100, 0.5)"
	size="large"
	color="#fff"
	type="line-scale-pulse-out">
	<span class="chevron left"></span>
	<span class="chevron right"></span>
</ngx-spinner>
<div class="m-grid__item m-grid__item--fluid m-wrapper">
	<div class="m-content">
		<!--begin::Portlet-->
		<!--begin::Form-->
		<form
			[formGroup]="stationForm"
			*ngIf="stationForm"
			class="m-form m-form--fit m-form--label-align-right">

				<div class="m-portlet">
		
					<div class="m-portlet__head">
						<div class="m-portlet__head-caption">
							<div class="m-portlet__head-title">
								<h3 class="m-portlet__head-text" *ngIf="!cue5050Id">
									POS STATION INFORMATION
								</h3>
								<span (click)="openStationInfo()" class="info-header-icon m-portlet__head-text">
									<img
										src="../../assets/app/media/img/icons/info-icon.png"
										class="tooltip-icon"
										style="position: relative; cursor: pointer;"
										tooltip="Click here for more information about Point Of Sale (POS) Stations"
										/>
								</span>
							</div>
						</div>
					</div>
		
					<div class="m-portlet__body">
						<div class="m-form__section m-form__section--first">

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Station Name:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="name"
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="stationFC('name')"
								errorMessage="Please provide a name for this station"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">
						Description:
						</label>
						<div class="col-lg-3">
							<input
								formControlName="description"
								type="text"
								id="name"
								class="form-control m-input"
								placeholder=""
								/>
							<app-validation-display
								[control]="stationFC('description')"
								errorMessage="Please provide a short decription of this station"
								></app-validation-display>
						</div>
					</div>

					<div class="form-group m-form__group row">
						<label class="col-lg-4 col-form-label">	
						Allow Guest Accounts:
						</label>
						<div style="padding-top: 7px;" class="col-lg-3">
							<label class="switch">
								<input
									formControlName="allowGuests"
									type="checkbox"
									/>
				
								<span class="slider round"></span>
								</label>
						</div>
					</div>

					</div>
				</div>	

			</div>	
			
			<app-location-form
					*ngIf="stationForm" 
					formName="STATION LOCATION"
					[disableForm]="true"
					[disableSelection]="false"
					[parentGroup]="stationForm"
					[locationData]="station?.location">
			</app-location-form>
        </form>

        <div class="form-group m-form__group row">
			<div class="col-lg-12">
				<button type="submit" (click)="save()" class="btn btn-primary">
				{{ stationId ? "Update" : "Create" }}
				</button>
				<button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
				Cancel
				</button>
				<div *ngIf="hasLocationErrors()">
					<span style="color:red">Please assign or create a location for this station</span>
				</div>
				<div *ngIf="hasStationErrors()">
					<span style="color:red">Please complete the required fields</span>
				</div>
			</div>
		</div>
    </div>
</div>